import { SVGProps, Ref, forwardRef } from 'react';

export const LocationOutlinedSize32Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={32} height={32} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="m15.969 16.031 2.118 7.566c.416 1.486.732 2.604 1.01 3.445.387-.797.847-1.864 1.455-3.282l4.29-10.008c1.58-3.687 2.654-6.209 3.15-8.035.246-.9.292-1.436.268-1.737-.016-.191-.049-.224-.24-.24-.301-.024-.837.022-1.737.267-1.826.497-4.349 1.572-8.035 3.152L8.24 11.448c-1.418.608-2.485 1.068-3.282 1.454.841.28 1.96.595 3.445 1.011zm1.333-11.08L7.294 9.241c-4.03 1.727-6.045 2.59-5.958 3.9s2.198 1.902 6.42 3.085l6.264 1.754 1.755 6.264c1.182 4.222 1.773 6.333 3.083 6.42s2.174-1.929 3.901-5.958l4.29-10.008c3.096-7.225 4.644-10.838 2.867-12.615-1.776-1.776-5.389-.228-12.614 2.868"
                fill="currentColor"
            />
        </g>
    </svg>
));
LocationOutlinedSize32Glyph.displayName = 'LocationOutlinedSize32Glyph';
